var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-2 rounded flex flex-row relative"},[_c('img',{staticClass:"max-h-16 max-w-16 object-contain rounded",attrs:{"src":_vm.image}}),_c('button',{staticClass:"absolute right-0",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"absolute right-0 fad fa-times-circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }